import React, { useState, useEffect, useMemo } from "react";

// ----------------------------------------------------------------------

const TABS = [
    {
        value: "c",
        label: "Visit Centre",
    },
    {
        value: "h",
        label: "Home Collection",
    },
];

// ----------------------------------------------------------------------

export function VisitTypeSwitchButton({
    handleVisitTypeChange,
    isHcAllowed,
    currentVisitType,
}) {
    const [activeTab, setActiveTab] = useState(currentVisitType);

    // Filter out the Home Visit tab if isHcAllowed is 0
    const availableTabs = useMemo(
        () =>
            isHcAllowed === 0 ? TABS.filter((tab) => tab.value === "c") : TABS,
        [isHcAllowed]
    );

    // Keep active tab in sync with prop
    useEffect(() => {
        setActiveTab(currentVisitType);
    }, [currentVisitType]);

    const handleTabClick = (tabValue) => {
        setActiveTab(tabValue);
        handleVisitTypeChange(null, tabValue);
    };

    // Figure out index of active tab
    const activeIndex = availableTabs.findIndex((t) => t.value === activeTab);

    return (
        <>
            <h4 className="mb-2 text-xs font-semibold uppercase tracking-wider text-slate-500">
                Visit Type
            </h4>
            <div className="mb-5">
                <div
                    role="tablist"
                    aria-label="Visit type"
                    className="relative flex rounded-lg bg-slate-100 p-1"
                >
                    {/* Sliding Indicator */}
                    <div
                        className="absolute top-1 bottom-1 left-1 rounded-md bg-white shadow-sm ring-1 ring-slate-200 transition-transform duration-300 ease-out"
                        style={{
                            width: `calc((100% - 8px) / ${availableTabs.length})`,
                            transform: `translateX(${
                                Math.max(activeIndex, 0) * 100
                            }%)`,
                        }}
                    />
                    {availableTabs.map((tab) => (
                        <button
                            key={tab.value}
                            type="button"
                            role="tab"
                            aria-selected={activeTab === tab.value}
                            onClick={() => handleTabClick(tab.value)}
                            className={`relative z-10 flex-1 cursor-pointer rounded-md px-3 py-2 text-sm font-semibold transition-colors duration-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/40 ${
                                activeTab === tab.value
                                    ? "text-primary"
                                    : "text-slate-600 hover:text-slate-900"
                            }`}
                        >
                            {tab.label}
                        </button>
                    ))}
                </div>
            </div>
        </>
    );
}
